module.exports = __webpack_public_path__ + "static/media/3.5bc70bcb.png";